import * as React from "react";
import { Context } from "./_context";
export const StopIcon = ({ size = 16, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[16] = /* @__PURE__ */ React.createElement("svg", { width: "1rem", height: "1rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.75 4a.25.25 0 0 1 .25.25v7.5a.25.25 0 0 1-.25.25h-7.5a.25.25 0 0 1-.25-.25v-7.5A.25.25 0 0 1 4.25 4h7.5Z", fill: "currentColor" }));
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M17.75 6a.25.25 0 0 1 .25.25v11.5a.25.25 0 0 1-.25.25H6.25a.25.25 0 0 1-.25-.25V6.25A.25.25 0 0 1 6.25 6h11.5Z", fill: "currentColor" }));
  return iconset[size];
};
StopIcon.iconId = "uLext7";
